export default {
    title: 'Domains',
    description: 'Serve your widget from your own domain instead of the default TransactionLink domain.',
    'add-button': 'Add domain',
    empty: 'No custom domains yet.',
    table: {
        name: 'Domain',
        status: 'Status',
        actions: 'Actions',
        'view-records': 'DNS records',
    },
    form: {
        label: 'Domain',
        placeholder: 'widget.customer.com',
        save: 'Add domain',
        'apex-hint': 'This is an apex (root) domain. Your DNS provider must support ALIAS or ANAME records — a plain CNAME cannot exist at the apex.',
        errors: {
            required: 'Enter a domain.',
            invalid: 'Enter a valid domain (for example widget.customer.com).',
            bareSuffix: 'Enter a full domain, not a public suffix like co.uk.',
            reserved: 'transactionlink.io domains cannot be used here.',
        },
    },
    status: {
        'pending-dns': 'Waiting for DNS records',
        verified: 'Domain verified - ready to deploy',
        deploying: 'Deploying (this can take a few minutes)',
        active: 'Live',
        'deploy-failed': 'Deployment failed',
        deleting: 'Removing…',
    },
    dns: {
        title: 'DNS records',
        instructions: 'Add these records at your DNS provider. Verification runs automatically and can take a few minutes after the records propagate.',
        headers: {
            host: 'Host',
            type: 'Type',
            value: 'Value',
        },
        'broken-record': 'This record doesn\'t match - check it at your DNS provider.',
        copied: 'Copied to clipboard',
    },
    deploy: {
        button: 'Deploy',
    },
    active: {
        'visit-label': 'Open',
    },
    failed: {
        'default-reason': 'Deployment failed.',
        'recovery-hint': 'This state cannot be recovered. Remove the domain and add it again.',
        'recovery-button': 'Remove and add again',
    },
    'workflow-picker': {
        label: 'Serve this workflow on',
        default: 'Default TransactionLink domain',
        'not-live-suffix': 'not live yet',
    },
    delete: {
        button: 'Delete',
        title: 'Delete domain',
        confirm: 'Delete "{domain}"? Widget links will fall back to the default TransactionLink domain immediately, and the customer domain will stop serving.',
        'confirm-button': 'Delete domain',
    },
}

// Backend error codes for custom domains. Spread into the global `errors` namespace in
// `texts/en.ts` so `errors.customDomain.*` / `errors.dns.*` still resolve at runtime.
export const errors = {
    customDomain: {
        notFound: 'This workflow has no custom domain assigned.',
        notVerified: 'The domain is not verified yet, so it cannot be deployed.',
        domain: {
            invalid: 'Enter a valid domain (for example widget.customer.com).',
        },
        workflow: {
            alreadyConfigured: 'This workflow is already served by another domain.',
        },
    },
    dns: {
        verification: {
            expired: 'DNS records were not set correctly within 7 days, so verification expired.',
        },
    },
}
